// extracted by mini-css-extract-plugin
module.exports = {"feedbackRow":"az_nMc","feedbackQuestion":"az_oMc","feedbackButtonsContainer":"az_pMc","thumbsContainer":"az_qMc","report":"az_rMc"};